import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Module } from 'app/library/module/models/module.model';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { FetchAllModules, FetchAllModulesFailure, FetchAllModulesSuccess } from '../actions';
import { AllModulesState } from '../models/all-modules.state';

@Injectable()
export class AllModulesService {
    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    getModules(): Module[] {
        return this._store.selectSnapshot(AllModulesState.getEntities);
    }

    async fetchAllModules(
        filterValues: { [key: string]: string[] } = null,
        search = '',
        sortBy = '',
        sortOrder = '',
        pageSize = 10,
        pageIndex = 1,
        kind = '',
        ids = ''
    ): Promise<boolean> {
        this._store.dispatch(new FetchAllModules({ filterValues, search, sortBy, sortOrder, pageSize, pageNumber: pageIndex, kind, ids }));

        return await this._actionHelper.race(FetchAllModulesSuccess, FetchAllModulesFailure).toPromise();
    }
}
